export default "__VITE_ASSET__C8gcZJ$U__"